/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InventoryConvertPathParams,
	InventoryConvertRequest,
	InventoryConvertResponse,
} from '../types/InventoryConvert'

/**
 * POST /:organisation/inventory/convert
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::convert
 */
export async function inventoryConvert(
	organisation: InventoryConvertPathParams['organisation'],
	data: InventoryConvertRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventoryConvertResponse>> {
	return axiosInstance.post(`/${organisation}/inventory/convert`, data, config)
}
